import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=057e19bd&scoped=true&"
import script from "./claim.vue?vue&type=script&lang=ts&"
export * from "./claim.vue?vue&type=script&lang=ts&"
import style0 from "./claim.vue?vue&type=style&index=0&id=057e19bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057e19bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
